export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["演示支付处理。"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["不使用真实交易或真实资金。仅用于功能演示。"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zentrolink"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["法律文件"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["服务条款"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["隐私政策"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datenschutzerklärung"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["返回管理页面"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["此文档暂不可用。"])}
}